import { render } from "./index.vue?vue&type=template&id=27384805&bindings={\"name\":\"props\",\"initials\":\"options\",\"wrapperStyle\":\"options\",\"colors\":\"data\"}"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "27384805"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27384805')) {
    api.reload('27384805', script)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=27384805&bindings={\"name\":\"props\",\"initials\":\"options\",\"wrapperStyle\":\"options\",\"colors\":\"data\"}", () => {
    api.rerender('27384805', render)
  })

}

script.__file = "resources/js/Components/InitialAvatar/index.vue"

export default script